import phone from 'phone';
import GOOGLE_LIBPHONENUMBER from 'google-libphonenumber';
const { PhoneNumberUtil, PhoneNumberFormat, AsYouTypeFormatter } = GOOGLE_LIBPHONENUMBER;
const PNF = PhoneNumberFormat;
const phoneUtil = PhoneNumberUtil.getInstance();
export class PhoneUtil {
    static isValid(phoneNumber, country) {
        return PhoneUtil.isValidLib(phoneNumber, country);
    }
    static asYouTypeFormatter(country) {
        return new AsYouTypeFormatter(country || 'JP');
    }
    static isValidPhone(phoneNumber, country) {
        if (!phoneNumber)
            return false;
        const response = phone(phoneNumber, country || 'JP');
        if (Array.isArray(response) && response.length > 0) {
            return true;
        }
        return false;
    }
    static isValidLib(phoneNumber, country) {
        if (!phoneNumber)
            return false;
        try {
            const number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.isValidNumberForRegion(number, country || 'JP');
        }
        catch (e) { }
        return false;
    }
    static formatE164(phoneNumber, country) {
        if (PhoneUtil.isValid(phoneNumber, country)) {
            const number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.format(number, PNF.E164);
        }
        return undefined;
    }
    static formatNational(phoneNumber, country) {
        if (PhoneUtil.isValid(phoneNumber, country)) {
            const number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.format(number, PNF.NATIONAL);
        }
        return undefined;
    }
    static formatInternational(phoneNumber, country) {
        if (PhoneUtil.isValid(phoneNumber, country)) {
            const number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.format(number, PNF.INTERNATIONAL);
        }
        return undefined;
    }
    static formatRFC3966(phoneNumber, country) {
        if (PhoneUtil.isValid(phoneNumber, country)) {
            const number = phoneUtil.parseAndKeepRawInput(phoneNumber, country || 'JP');
            return phoneUtil.format(number, PNF.RFC3966);
        }
        return undefined;
    }
}
